module.exports = __webpack_public_path__ + "img/09-b2c72f.png";